// Import Configs
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';
// Import Types
import { NotificationListResponse } from 'components/Header/types';

const NotificationHttpService = {
    getNotificationList: () => {
        return getCancelableRequest<NotificationListResponse>({
            requestService: CRMRequestService,
            endpointPath: () => '/EventLogNotification/GetUserNotifications',
        });
    },
    markAsRead: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/EventLogNotification/MarkAsRead',
        });
    },
    markAsUnread: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/EventLogNotification/MarkAsUnread',
        });
    },
    markAllAsRead: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/EventLogNotification/MarkAllAsRead',
        });
    },
};

export default NotificationHttpService;
